import React from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';

const VCPricingSection = () => (
    <section className="lp-vcprice">
        <div className="lp-vcprice-inner">
            <div className="lp-vcprice-head">
                <h2 className="lp-h2" data-lp-reveal>What does it cost?</h2>
            </div>
            <div className="lp-vcprice-grid">
                {/* The VC card is the highlighted (dark) one — the firm never pays. */}
                <div className="lp-vcprice-card is-highlight" data-lp-reveal>
                    <div className="lp-vcprice-tag">VC Firm</div>
                    <h3>Free</h3>
                    <div className="lp-vcprice-amount">£0</div>
                    <p>No platform fees, no licence costs, no commitment. Investor access is always free on Diligentsia.</p>
                </div>
                <div className="lp-vc-price-card lp-vc-price-card--paid" data-lp-reveal data-lp-delay="100">
                    <div className="label">Portfolio / Applicant Company</div>
                    <div className="price">£83.25<span>/ mo</span></div>
                    <p>£999/yr, billed annually. Portfolio company rate: £66.67/mo (£800/yr — 20% off via your firm). Companies bear the cost — not your firm.</p>
                    <a href="#">Full pricing →</a>
                </div>
            </div>
            <div className="lp-vcprice-foot" data-lp-reveal>
                <Link to={ROUTES.PRICING_PLAN}>Full pricing →</Link>
            </div>
        </div>
    </section>
);

export default VCPricingSection;
